import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCj5QCv9laxUBqnHbXYAxaU6274HISiHlc",
  authDomain: "blog-app-5dfc0.firebaseapp.com",
  projectId: "blog-app-5dfc0",
  storageBucket: "blog-app-5dfc0.appspot.com",
  messagingSenderId: "727062339693",
  appId: "1:727062339693:web:7187cd706f883c981c1f64",
  measurementId: "G-SK8RQQW4Q1",
};

firebase.initializeApp(firebaseConfig);
export default firebase;
